import React from 'react'
import { Routes, Route } from "react-router-dom"

import NavBar from './Components/NavBar/NavBar'
import Home from "./Pages/Home/Home"
import CarDesign from './Pages/CarDesign/CarDesign'
import About from './Components/About/About'
import Contact from './Components/Contact/Contact'
import Fluxstore from './Pages/Fluxstore/Fluxstore'
import Footer from './Components/Footer/Footer'
import Description from "./Components/Description/Description"
import Dashboard from './Pages/Dashboard/Dashboard'
import Login from "./Components/Login/Login"
import Signup from "./Components/Signup/Signup"
import Subscribe from './Components/Subscribe/Subscribe'

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import "./App.scss"
import Checkout from './Pages/Fluxstore/Checkout/Checkout'
import Privacy from './Pages/Privacy/Privacy'
import Terms from './Pages/Terms/Terms'






const HomePage = () => {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='design' element={<CarDesign />} />
        <Route path='store' element={<Fluxstore />} />
        <Route path='about' element={<About />} />
        <Route path='contact' element={<Contact />} />
        <Route path='subscribe' element={<Subscribe />} />
        <Route path='cart' element={<Checkout />} />
        <Route path='privacy' element={<Privacy />} />
        <Route path='terms' element={<Terms />} />



      </Routes>
      <Footer />
      <Description />
    </>
  )
}

const App = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='dark'
      />
      <Routes>
        <Route path='/*' element={<HomePage />} />
        {/* <Route path='design' element={<CarDesign />} /> */}
        <Route path='login' element={<Login />} />
        <Route path='signup' element={<Signup />} />
        <Route path='dashboard/*' element={<Dashboard />} />
      </Routes>
    </>
  )
}

export default App